


























import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {TabBase} from "@/views/Vozila/PodaciVozila/TabBase";
import {State} from "vuex-class";
import {B2BPodatakVozila, Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';

@Component({})
export default class Tab5 extends TabBase {
    @State vozilo!: Vozilo;
    b2bPodaci: B2BPodatakVozila[] = [];

    @Watch('vozilo') async onVoziloChanged(vozilo: Vozilo) {
        if (vozilo.id) {
            this.b2bPodaci = await dataProxy.vratiB2BPodatkeVozila(vozilo.id);
        }
    }

    async handleSave() {
        this.b2bPodaci = await this.saveData(() => dataProxy.sacuvajB2BPodatkeVozila(this.vozilo.id, this.b2bPodaci.filter(x => x.vrednost)))();
    }
}
